import React, { useMemo } from "react";
import { useTranslate } from "@refinedev/core";
import { DocumentPositionPoint } from "types/";
import { AnalyticsBarChart, type BarDatasetConfig } from "./AnalyticsBarChart";
import { analyticsTheme } from "./analyticsTheme";
import { getPercentageAxis, getCategoryAxis, withClippedTicks } from "./utils/";

const T_PREFIX = "media.projects.analytics.documentHighlighter.scrollDensity";

export interface ScrollDensityChartProps {
  data: DocumentPositionPoint[] | undefined;
  loading: boolean;
}

export const ScrollDensityChart: React.FC<ScrollDensityChartProps> = ({
  data,
  loading,
}) => {
  const t = useTranslate();
  const chartOptions = useMemo(
    () => ({
      scales: { y: getPercentageAxis(), x: withClippedTicks(getCategoryAxis()) },
    }),
    []
  );

  const points = data ?? [];

  const labels = useMemo(
    // page_number is 0-indexed from the API; display it 1-based for readers.
    () => points.map((p) => `p.${p.page_number + 1}`),
    [points]
  );

  const datasets = useMemo<BarDatasetConfig[]>(
    () => [
      {
        label: t(`${T_PREFIX}.scrollEvents`),
        data: points.map((p) => Math.round(p.sessions_pct * 100) / 100),
        color: analyticsTheme.datasetEmerald,
      },
    ],
    [points, t]
  );

  return (
    <AnalyticsBarChart
      title={t(`${T_PREFIX}.title`)}
      subtitle={t(`${T_PREFIX}.subtitle`)}
      labels={labels}
      datasets={datasets}
      loading={loading}
      direction="vertical"
      height={200}
      chartOptions={chartOptions}
    />
  );
};
